import { OriginalTargetBufferDecreaser } from '@bufferController/PlaybackSpeedController/OriginalTargetBufferDecreaser/OriginalTargetBufferDecreaser';
import { PlaybackSpeedActuator } from '@bufferController/PlaybackSpeedController/PlaybackSpeedActuator/PlaybackSpeedActuator';
import { PlaybackSpeedWatcher } from '@bufferController/PlaybackSpeedController/PlaybackSpeedWatcher/PlaybackSpeedWatcher';
import { TargetBufferDecreaser } from '@bufferController/PlaybackSpeedController/TargetBufferDecreaser/TargetBufferDecreaser';
import { TargetBufferIncreaser } from '@bufferController/PlaybackSpeedController/TargetBufferIncreaser/TargetBufferIncreaser';
import { EDebuggableModuleState, IDebbugable, TDebuggableAdditionalInfo } from '@customTypes/common';
import { TEventBus } from '@eventBus/EventBus';

export class PlaybackSpeedController implements IDebbugable {
  public _eventBus: TEventBus;
  public state: EDebuggableModuleState = EDebuggableModuleState.OK;
  public status: string = 'Idle';
  public groups: string[] = ['PlaybackSpeed'];

  public additionalInfo: TDebuggableAdditionalInfo = {};

  private readonly _playbackSpeedActuator: PlaybackSpeedActuator;
  private readonly _playbackSpeedWatcher: PlaybackSpeedWatcher;
  private readonly _targetBufferDecreaser: TargetBufferDecreaser;
  private readonly _targetBufferIncreaser: TargetBufferIncreaser;
  private readonly _originalTargetBufferDecreaser: OriginalTargetBufferDecreaser;

  constructor(eventBus: TEventBus) {
    this._eventBus = eventBus;
    this._playbackSpeedActuator = new PlaybackSpeedActuator(this._eventBus);
    this._playbackSpeedWatcher = new PlaybackSpeedWatcher(this._eventBus);
    this._targetBufferDecreaser = new TargetBufferDecreaser(this._eventBus);
    this._targetBufferIncreaser = new TargetBufferIncreaser(this._eventBus);
    this._originalTargetBufferDecreaser = new OriginalTargetBufferDecreaser(this._eventBus);
  }

  public setVideoElement(videoElement: HTMLVideoElement): void {
    this._playbackSpeedActuator.setVideoElement(videoElement);
  }

  public removeVideoElement(): void {
    this._playbackSpeedActuator.setVideoElement(null);
  }

  public pause(): void {
    this._playbackSpeedWatcher.pause();
  }

  public resume(): void {
    this._playbackSpeedWatcher.resume();
  }

  public destroy(): void {
    this._playbackSpeedActuator.destroy();
    this._playbackSpeedWatcher.destroy();
    this._targetBufferDecreaser.destroy();
    this._targetBufferIncreaser.destroy();
    this._originalTargetBufferDecreaser.destroy();
  }

  get additionalModules(): Record<string, IDebbugable> {
    return {
      playbackSpeedActuator: this._playbackSpeedActuator,
      playbackSpeedWatcher: this._playbackSpeedWatcher,
      targetBufferIncreaser: this._targetBufferIncreaser,
      targetBufferDecreaser: this._targetBufferDecreaser,
      originalTargetBufferDecreaser: this._originalTargetBufferDecreaser,
    };
  }
}
